export default {
  label: '销售经理',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '销售总监是公司高层管理职位，负责公司整体销售战略的制定和实施',
          id: '0-1-1'
        }
      ]
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '制定年度销售策略，调整价格和促销政策',
          id: '0-2-1'
        },
        {
          label: '建立客户关系，开发新市场，完成销售目标',
          id: '0-2-2'
        },
        {
          label: '组织和管理销售团队，进行团队目标绩效管理',
          id: '0-2-3'
        },
        {
          label: '分析市场趋势，制定营销战略',
          id: '0-2-4'
        },
        {
          label: '推动产品差异化，优化资源利用',
          id: '0-2-5'
        },
        {
          label: '监督销售活动的策划和推行',
          id: '0-2-6'
        }
      ]
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '本科及以上学历，8年以上销售工作经验',
          id: '0-3-1'
        },
        {
          label: '强大的市场触觉和逻辑分析能力',
          id: '0-3-2'
        },
        {
          label: '出色的人际交往和协调能力',
          id: '0-3-3'
        },
        {
          label: '良好的团队合作精神和解决问题的能力',
          id: '0-3-4'
        }
      ]
    }
  ]
}